import { render, staticRenderFns } from "./TicketHistoryComponent.vue?vue&type=template&id=157b3c43&scoped=true"
import script from "./TicketHistoryComponent.vue?vue&type=script&lang=js"
export * from "./TicketHistoryComponent.vue?vue&type=script&lang=js"
import style0 from "./TicketHistoryComponent.vue?vue&type=style&index=0&id=157b3c43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157b3c43",
  null
  
)

export default component.exports